import { useEffect, useMemo, useState } from "preact/hooks"
import register from "preact-custom-element"

const optionsToString = (options) => {
  if (!options.freq) return ""
  const parts = [`FREQ=${options.freq}`]

  if (options.interval && options.interval !== "1") {
    ;[parts.push(`INTERVAL=${options.interval}`)]
  }

  if (
    options.freq === "MONTHLY" &&
    options.monthlyoption === "bymonthday" &&
    options.bymonthday
  ) {
    parts.push(`bymonthday=${options.bymonthday}`)
  }

  if (
    options.freq === "MONTHLY" &&
    options.monthlyoption === "byweekday" &&
    options.byweekday &&
    options.byweekday_freq
  ) {
    parts.push(`byweekday=${options.byweekday}(${options.byweekday_freq})`)
  }

  if (options.until) {
    parts.push(`UNTIL=${options.until.replace(/-/g, "")}T235959Z`)
  }

  return parts.join(";")
}

const rruleToOptions = (value) => {
  const options = {
    freq: "",
    until: null,
    interval: 1,
    monthlyoption: "bymonthday",
    bymonthday: "1",
    byweekday: "MO",
    byweekday_freq: "1",
  }
  let v
  if ((v = value.match(/FREQ=([A-Z]+)/))) {
    options.freq = v[1]
  }
  if ((v = value.match(/INTERVAL=(\d+)/))) {
    options.interval = v[1]
  }
  if ((v = value.match(/bymonthday=(\d+)/))) {
    options.monthlyoption = "bymonthday"
    options.bymonthday = v[1]
  }
  if ((v = value.match(/byweekday=(\w{2})\((-?\d+)\)/))) {
    options.monthlyoption = "byweekday"
    options.byweekday = v[1]
    options.byweekday_freq = v[2]
  }
  if ((v = value.match(/UNTIL=([0-9]{4})([0-9]{2})([0-9]{2})T/))) {
    options.until = `${v[1]}-${v[2]}-${v[3]}`
  }
  return options
}

let __id = 0

const RRuleWidget = ({ start, target }) => {
  const startEl = useMemo(() => document.getElementById(start), [start])
  const targetEl = useMemo(() => document.getElementById(target), [target])

  const [widgetId] = useState(() => `rrule${++__id}`)

  const [_startDate, setStartDate] = useState(() => {
    return startEl.value ? new Date(startEl.value) : new Date()
  })
  useEffect(() => {
    const listener = () => {
      setStartDate(startEl.value ? new Date(startEl.value) : new Date())
    }
    startEl.addEventListener("input", listener)
    return () => {
      startEl.removeEventListener("input", listener)
    }
  }, [startEl])

  const [options, setOptions] = useState(() => rruleToOptions(targetEl.value))

  useEffect(() => {
    targetEl.value = optionsToString(options)
    console.debug("RRuleWidget", options, targetEl.value)
  })

  const choices = [
    ["", "Keine Wiederholung"],
    ["DAILY", "Täglich"],
    ["WEEKLY", "Wöchentlich"],
    ["MONTHLY", "Monatlich"],
  ]

  const weekday_freq_choices = [
    [1, "ersten"],
    [2, "zweiten"],
    [3, "dritten"],
    [4, "vierten"],
    [-1, "letzten"],
    [-2, "vorletzten"],
  ]
  const weekday_choices = [
    ["MO", "Mo"],
    ["TU", "Di"],
    ["WE", "Mi"],
    ["TH", "Do"],
    ["FR", "Fr"],
    ["SA", "Sa"],
    ["SU", " So"],
  ]

  return (
    <>
      <div class="field">
        <label for={`${widgetId}_freq`}>Wiederholung</label>
        <select
          id={`${widgetId}_freq`}
          value={options.freq}
          onInput={(e) => {
            setOptions((o) => ({
              ...o,
              freq: e.target.value,
              interval: 1,
            }))
          }}
        >
          {choices.map(([value, title]) => (
            <option value={value} key={value}>
              {title}
            </option>
          ))}
        </select>
      </div>
      {options.freq === "WEEKLY"
        ? <div class="fields--inline">
            <span>Alle</span>
            <div class="field field--inline -short">
              <label for={`${widgetId}_interval`}>
                <input
                  id={`${widgetId}_interval`}
                  type="number"
                  min="1"
                  step="1"
                  max="50"
                  value={options.interval}
                  onInput={(e) => {
                    setOptions((o) => ({ ...o, interval: e.target.value }))
                  }}
                />{" "}
              </label>
            </div>
            <span>{(options.interval || 1) > 1 ? "Wochen" : "Woche"}.</span>
            <RRuleUntil
              widgetId={widgetId}
              options={options}
              setOptions={setOptions}
            />
          </div>
        : options.freq === "MONTHLY"
          ? <>
              <div class="fields--options">
                <div class="fields--inline">
                  <input
                    type="radio"
                    checked={options.monthlyoption === "bymonthday"}
                    onClick={() => {
                      setOptions((o) => ({
                        ...o,
                        monthlyoption: "bymonthday",
                      }))
                    }}
                  />
                  <span>am</span>
                  <div class="field field--inline -short">
                    <select
                      id={`${widgetId}_bymonthday`}
                      value={options.bymonthday}
                      onInput={(e) => {
                        setOptions((o) => ({
                          ...o,
                          monthlyoption: "bymonthday",
                          bymonthday: e.target.value,
                        }))
                      }}
                    >
                      {[...new Array(31).keys()].map((i) => (
                        <option key={i} value={i + 1}>
                          {i + 1}.
                        </option>
                      ))}
                    </select>
                  </div>{" "}
                  <span>des Monats</span>
                </div>
                <div class="fields--inline">
                  <input
                    type="radio"
                    checked={options.monthlyoption === "byweekday"}
                    onClick={() => {
                      setOptions((o) => ({
                        ...o,
                        monthlyoption: "byweekday",
                      }))
                    }}
                  />
                  <span>jeden</span>
                  <div class="field field--inline -short">
                    <select
                      id={`${widgetId}_byweekday_freq`}
                      value={options.byweekday_freq}
                      onInput={(e) => {
                        setOptions((o) => ({
                          ...o,
                          monthlyoption: "byweekday",
                          byweekday_freq: e.target.value,
                        }))
                      }}
                    >
                      {weekday_freq_choices.map((choice) => (
                        <option key={choice[0]} value={choice[0]}>
                          {choice[1]}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div class="field field--inline -short">
                    <select
                      id={`${widgetId}_byweekday`}
                      value={options.byweekday}
                      onInput={(e) => {
                        setOptions((o) => ({
                          ...o,
                          monthlyoption: "byweekday",
                          byweekday: e.target.value,
                        }))
                      }}
                    >
                      {weekday_choices.map((choice) => (
                        <option key={choice[0]} value={choice[0]}>
                          {choice[1]}
                        </option>
                      ))}
                    </select>
                  </div>
                  <span>des Monats.</span>
                </div>
              </div>
              <RRuleUntil
                widgetId={widgetId}
                options={options}
                setOptions={setOptions}
              />
            </>
          : options.freq
            ? <RRuleUntil
                widgetId={widgetId}
                options={options}
                setOptions={setOptions}
              />
            : null}
    </>
  )
}

const RRuleUntil = ({ options, widgetId, setOptions }) => (
  <div class="field field--inline">
    <label for={`${widgetId}_until`}>Wiederholen bis</label>
    <input
      id={`${widgetId}_until`}
      type="date"
      value={options.until}
      onInput={(e) => {
        setOptions((o) => ({ ...o, until: e.target.value }))
      }}
    />
  </div>
)

register(RRuleWidget, "rrule-widget", ["for"], { shadow: false })
